import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { isAnswered } from "../../../../utils/QuestionUtils";
import QuestionHeader from "./QuestionHeader";
import RadioRenderer from "./renderer/RadioRenderer";

/**
 * Radio group question component for survey-view.
 */
const RadiogroupQuestion = ({
  disabled,
  question,
  questionAnswer,
  setQuestionAnswer,
  removeQuestionAnswer,
  isActivityMonitoring
}) => {
  const collection = questionAnswer.answers;
  const answered = isAnswered(question, questionAnswer);
  return (
    <Row>
      <Col lg={12} md={12} sm={12}>
        <QuestionHeader question={question} answered={answered}>
          <RadioRenderer
            disabled={disabled}
            question={question}
            collection={collection}
            setQuestionAnswer={setQuestionAnswer}
            removeQuestionAnswer={removeQuestionAnswer}
            isActivityMonitoring={isActivityMonitoring}
            isIncomplete={!answered}
          />
        </QuestionHeader>
      </Col>
    </Row>
  );
};

RadiogroupQuestion.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  setQuestionAnswer: PropTypes.func,
  removeQuestionAnswer: PropTypes.func,
  isActivityMonitoring: PropTypes.bool
};

export default RadiogroupQuestion;
